export enum ShipmentHeadedStatus {
  RightHeaded = 'RIGHT_HEADED',
  WrongHeaded = 'WRONG_HEADED',
}
